// 단축URL 관리 API — 백엔드 kr.taplink.link.LinkController / kr.taplink.qr.QrController
// 타입은 OpenAPI 계약에서 생성된 것을 그대로 쓴다(DSN-3) — 손으로 다시 쓰면 드리프트한다
import type { Schemas } from "@taplink/api-client";
import { request } from "@taplink/web-shared";
import { getToken } from "@taplink/web-shared";

export type Link = Schemas["LinkResponse"];
export type CreateLinkInput = Schemas["CreateLinkRequest"];
export type UpdateLinkInput = Schemas["UpdateLinkRequest"];

export const linkApi = {
  list: (page = 0, size = 20) => request<Link[]>(`/short-urls?page=${page}&size=${size}`),

  create: (input: CreateLinkInput) =>
    request<Link>("/short-urls", { method: "POST", body: input }),

  update: (shortKey: string, patch: UpdateLinkInput) =>
    request<Link>(`/short-urls/${shortKey}`, { method: "PATCH", body: patch }),

  remove: (shortKey: string) => request<void>(`/short-urls/${shortKey}`, { method: "DELETE" }),
};

/**
 * QR 이미지를 가져온다.
 *
 * QR 엔드포인트는 인증이 필요해 `<img src>`로 직접 부를 수 없다
 * (브라우저가 Authorization 헤더를 붙이지 못함) → blob으로 받아 objectURL을 만든다.
 * 호출부는 사용 후 반드시 `URL.revokeObjectURL`로 해제해야 한다.
 */
export async function fetchQrObjectUrl(
  shortKey: string,
  format: "PNG" | "SVG",
  size = 320,
): Promise<string> {
  const response = await fetch(
    `/api/v1/short-urls/${shortKey}/qr?format=${format}&size=${size}`,
    { headers: { Authorization: `Bearer ${getToken() ?? ""}` } },
  );
  if (!response.ok) throw new Error("QR 이미지를 불러오지 못했습니다.");
  return URL.createObjectURL(await response.blob());
}
